module.exports = __webpack_public_path__ + "static/media/199-1995584_shopify-shopify-logo-png-removebg-preview.e7c2005e.png";